
/**
 * Validation utilities for business onboarding forms
 */

export interface ValidationError {
  field: string;
  message: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
}

export const validateBusinessInfo = (data: {
  name: string;
  industry: string;
}): ValidationResult => {
  const errors: ValidationError[] = [];
  
  if (!data.name || data.name.trim() === '') {
    errors.push({
      field: 'name',
      message: 'Business name is required'
    });
  }
  
  if (!data.industry || data.industry.trim() === '') {
    errors.push({
      field: 'industry',
      message: 'Industry is required'
    });
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export const validateOnlinePresence = (data: {
  website: string;
}): ValidationResult => {
  const errors: ValidationError[] = [];
  
  if (!data.website || data.website.trim() === '') {
    errors.push({
      field: 'website',
      message: 'Website URL is required'
    });
  } else {
    // Simple URL validation
    try {
      // Add https:// if missing
      const url = data.website.startsWith('http') 
        ? data.website 
        : `https://${data.website}`;
      
      new URL(url);
    } catch (e) {
      errors.push({
        field: 'website',
        message: 'Please enter a valid website URL'
      });
    }
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export const validateBrandVoice = (data: {
  brandVoice: string;
}): ValidationResult => {
  const errors: ValidationError[] = [];
  
  if (!data.brandVoice || data.brandVoice.trim() === '') {
    errors.push({
      field: 'brandVoice',
      message: 'Brand voice description is required'
    });
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};
